import React, { useState } from 'react'
import classNames from 'classnames'

import { Select } from '@zambezi/sdk/dropdown-list'
import { IsViewport } from '@zambezi/layout-grid'
import TabBar from '@zambezi/sdk/tab-bar'

import PaymentDetails from '@apiEnabler/ob-common/lib/view/stores/PaymentDetails'
import DateTimeWarning from '@apiEnabler/ob-common/lib/view/DateTimeWarning'
import {
  sweepingDescriptiveDate,
  getHistoryForCurrentUser,
} from '@apiEnabler/ob-common/lib/sweeping-consents'

import ConsentOverviewHeader from './ConsentOverviewHeader'
import NavBar, { NavItem } from './NavBar'
import PaymentHistoryEntries from './PaymentHistoryEntries'
import { VrpDescriptiveMessage } from './VrpPayment'

import style from './SweepingPayment.module.scss'

export default function SweepingPayment({
  consent,
  brand,
  tpp,
  onCancelAccess,
  isStaffMember,
}) {
  const allHistoryTypes = ['Payment', 'Connection']
  const { label, date } = sweepingDescriptiveDate(consent)
  const handleCancel = createCancelHandler(consent, onCancelAccess)
  const [historyType, setHistoryType] = useState(allHistoryTypes[0])
  const historyEntries =
    historyType === 'Payment'
      ? consent.get('activities')
      : getHistoryForCurrentUser(consent, isStaffMember)
  const selectedHistoryTabIndex = allHistoryTypes.indexOf(historyType)
  return (
    <section className="js-access-container">
      <header className={style.header}>
        <div className={style.headerContent}>
          <NavBar
            items={[
              new NavItem({
                label: 'Sweeping payments',
                link: '/recurring-payments/sweeping/tpps',
              }),
              new NavItem({
                label: tpp.clientDisplayName,
                link: `/recurring-payments/sweeping/tpps/${tpp.clientId}/payments`,
              }),
            ]}
            padded
          />
          <ConsentOverviewHeader
            dateLabel={label}
            dateValue={date}
            description={
              <SweepingDescriptiveMessage consent={consent} tpp={tpp} />
            }
            onCancel={handleCancel}
            cancelLabel="Cancel payment access"
            consentStatus={consent.get('status')}
          />
        </div>
      </header>

      <section className={style.content}>
        <PaymentDetails payment={consent} brand={brand} />
        <h2
          id="history-title"
          className={`${style.sectionHeading} js-history-title`}
        >
          History
        </h2>
        <IsViewport isWidescreen isDesktop>
          <TabBar
            className={classNames(style.historyTabs, 'js-history-tabs')}
            data={allHistoryTypes}
            selectedIndex={selectedHistoryTabIndex}
            onSelected={historyType => {
              setHistoryType(historyType)
            }}
          />
          <PaymentHistoryEntries
            historyType={historyType}
            historyEntries={historyEntries}
          />
        </IsViewport>
        <IsViewport isTablet isMobile>
          <Select
            className={classNames(style.historyTypeSelector, 'js-history-tabs')}
            defaultValue={historyType}
            suggestions={allHistoryTypes}
            onSuggestionSelected={(e, { suggestion }) => {
              setHistoryType(suggestion)
            }}
          />
          <PaymentHistoryEntries
            historyType={historyType}
            historyEntries={historyEntries}
            isMobile
          />
        </IsViewport>

        <DateTimeWarning />
      </section>
    </section>
  )
}

function createCancelHandler(access, onCancelAccess) {
  if (onCancelAccess && access.get('grouping') === 'ACTIVE') {
    return () => {
      onCancelAccess(access)
    }
  }
  return null
}

function SweepingDescriptiveMessage({ consent, tpp }) {
  return <VrpDescriptiveMessage consent={consent} tpp={tpp} />
}
